import { useQuery } from "react-query";
import { fetchAPIAddresses } from "../requests/Addresses";

export function useQueryAddresses(id: number) {
    const onError = () => {};
    const query = useQuery("apiQueryAddresses", async () => await fetchAPIAddresses(id), { onError });
    return query;
}